var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 80,
    fill: "#EEF2FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 61,
    r: 25,
    stroke: "#1234CD",
    strokeWidth: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 132C39 105 55 92 80 92C105 92 121 105 125 132",
    stroke: "#1234CD",
    strokeWidth: 9,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlaceholder);
export default __webpack_public_path__ + "static/media/profile-placeholder.31ca1c2db212b12273001240847f3d8a.svg";
export { ForwardRef as ReactComponent };